// Kaching Cart general fixes/events (applies site-wide, independent of any AB test)

let minicartOpen = false;
let outsideClickHandler = null;

function isKachingCartOpen(cart) {
  return cart.classList.contains("active") || cart.getAttribute("data-open") === "true";
}

// Kaching Cart doesn't reliably close on outside click, so we replicate it here
// by triggering its own close button when a click lands outside the drawer.
function attachOutsideClickClose(cart) {
  // Deferred so the click that just opened the cart (e.g. the header cart icon)
  // isn't also treated as an "outside click" that immediately closes it again.
  setTimeout(() => {
    outsideClickHandler = function (event) {
      if (!isKachingCartOpen(cart) || cart.contains(event.target)) return;
      const closeBtn = cart.querySelector(".kaching-cart__close");
      if (closeBtn) closeBtn.click();
    };
    document.addEventListener("click", outsideClickHandler);
  }, 0);
}

function detachOutsideClickClose() {
  if (outsideClickHandler) {
    document.removeEventListener("click", outsideClickHandler);
    outsideClickHandler = null;
  }
}

function checkKachingCartState() {
  const cart = document.getElementById("kaching-cart");
  if (!cart) return;

  const open = isKachingCartOpen(cart);
  if (open && !minicartOpen) {
    window.igEvents = window.igEvents || [];
    window.igEvents.push({ event: "opens_minicart" });
    attachOutsideClickClose(cart);
  } else if (!open && minicartOpen) {
    detachOutsideClickClose();
  }
  minicartOpen = open;
}

function setupKachingCartWatcher() {
  checkKachingCartState();

  const observer = new MutationObserver(checkKachingCartState);
  observer.observe(document.body, {
    attributes: true,
    attributeFilter: ["class", "data-open"],
    subtree: true,
    childList: true,
  });
}

document.addEventListener("DOMContentLoaded", setupKachingCartWatcher);